export default "__VITE_ASSET__BEEori$P__"